module.exports = __webpack_public_path__ + "img/@logo_nintendo@3x.392b6f32.png";